import * as React from 'react';
import { useBreakpoint } from 'hooks';
import styled from 'styled-components';
import { AuthContext } from 'contexts';
import { buildGoogleMapsAddress } from 'utils';
import PendingListingWarning from './PendingListingWarning';
import PublicAttachments, { PublicAttachmentType } from './PublicAttachments';
import Header from './Header';
import About from './About';
import theme from '../../theme';

import ListingViewCarousel from '../../../app/DashboardComponents/ListingViewCarousel';
import { CarouselAsset } from '../../../app/DashboardComponents/ListingViewCarousel/types';

import { QuickActionButtons } from './QuickActionButtons';

interface ListingDetailsPageProps {
  listing: any;
  photos: any[];
  attachments: any[];
  fromTourPage?: boolean;
  closeModal: () => void;
  // Optional Favourites
  isFavorite?: boolean;
  toggleFavorite?: () => void;
}

const ListingDetailsPage: React.FC<ListingDetailsPageProps> = ({
  listing,
  photos,
  attachments,
  fromTourPage,
  closeModal,
  // Optional Favourites
  isFavorite,
  toggleFavorite,
}) => {
  const { md } = useBreakpoint();

  const { auth } = React.useContext(AuthContext);

  const generateAssets = () => {
    const imageUrls = photos
      .sort((a, b) => a.order - b.order)
      .map(image => image.url);

    let assets: CarouselAsset[] = [];
    if (listing.neighborhood !== 'Pending') {
      const address = buildGoogleMapsAddress(listing);
      assets.push({ type: 'map', address });
    }

    assets = assets.concat(
      imageUrls.map(url => ({
        type: 'image',
        url,
      })),
    );

    if (assets.length > 1 && listing.neighborhood !== 'Pending') {
      const [first, second] = assets;
      assets[0] = second;
      assets[1] = first;
    }
    return assets;
  };
  const carouselAssets = generateAssets();
  return (
    <StyledBorderDiv fromTourPage={fromTourPage}>
      <Header
        listing={listing}
        closeModal={closeModal}
        fromTourPage={fromTourPage}
      />
      <StyledCarouselContainer>
        <ListingViewCarousel carouselAssets={carouselAssets} showMobile={!md} />
        {Boolean(toggleFavorite && listing.id) && (
          <QuickActionButtons
            listingId={listing.id}
            isFavorite={isFavorite}
            toggleFavorite={toggleFavorite}
          />
        )}
      </StyledCarouselContainer>
      <About auth={auth} listing={listing} attachments={attachments} />
    </StyledBorderDiv>
  );
};

const StyledBorderDiv = styled.div<{ fromTourPage?: boolean }>`
  ${({ fromTourPage }) =>
    !fromTourPage &&
    `
    border: 1px solid ${theme.gray4};
    padding: 10px;
  `}
`;

const StyledCarouselContainer = styled.div`
  height: auto;
  max-height: 500px;
  position: relative;
`;

export {
  ListingDetailsPage,
  PublicAttachments,
  PublicAttachmentType,
  PendingListingWarning,
};
